module.exports = {"id":"191005","name":"Ahmed Elmohamady","rating":"72","photo":"./data/images/photos/4/191005.png","club":{"name":"Aston Villa","logo":"./data/images/clubs/AstonVilla.png"},"positions":["DD","DLD","MD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AhmedElmohamady0.json
// module id = 128
// module chunks = 0